import { array, string } from 'prop-types';
import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import { Comment, EmptyComments } from './comment';
import CommentInput from './comment-input';
export const Comments = ({ cellComments, classificationId, documentComparisonFileId, }) => {
    Comments.propTypes = {
        classificationId: string.isRequired,
        documentComparisonFileId: string.isRequired,
        cellComments: array,
    };
    return (React.createElement(PermissionChecker, { requiredAnyPermissions: [
            Permissions.VIEW_CLAUSE_COMMENTS,
            Permissions.CREATE_CLAUSE_COMMENTS,
        ] },
        React.createElement("div", { className: 'comments' },
            React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_CLAUSE_COMMENTS] },
                React.createElement("div", { className: 'comment-list' }, cellComments === null || cellComments === void 0 ? void 0 :
                    cellComments.map(comment => (React.createElement(Comment, { key: comment.id, comment: comment }))),
                    (!cellComments || (cellComments === null || cellComments === void 0 ? void 0 : cellComments.length) === 0) && React.createElement(EmptyComments, null))),
            React.createElement(CommentInput, { ids: { classificationId, documentComparisonFileId } }))));
};
